// import * as $ from 'jquery';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as is from 'is_js';
import * as cookiebar from './components/CookieBar';

// window.$ = $;
// window.jQuery = $;
window.bootstrap = bootstrap;
window.is = is;